import {
  CheckCircle,
  CheckCircleOutline,
  DoNotDisturb,
  FavoriteBorder as FavoriteBorderIcon,
  Favorite as FavoriteIcon,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import { PlanWeek, WorkoutStatusEnum } from "@readyfit-common/models";
import { NoDataIcon } from "src/grading/assets";
import useStyles from "./ChatTrainingScheduleWeek.style";

interface TrainingScheduleProps {
  planWeek: PlanWeek;
}

const RenderWorkoutStatusCheck = (workoutStatusId: string) => {
  if (workoutStatusId === WorkoutStatusEnum.didIt) {
    return <CheckCircle sx={{ color: "#27AE60" }} />;
  }

  if (workoutStatusId === WorkoutStatusEnum.noResults) {
    return <RadioButtonUnchecked />;
  }

  if (workoutStatusId === WorkoutStatusEnum.didNotDoIt) {
    return <DoNotDisturb style={{ color: "#EB5757" }} />;
  }

  if (workoutStatusId === WorkoutStatusEnum.partiallyDone) {
    return <CheckCircleOutline />;
  }

  return null;
};

export default function TrainingScheduleWeek({
  planWeek,
}: TrainingScheduleProps) {
  const _classes = useStyles();

  if (!planWeek?.workouts?.length) {
    return (
      <Grid container flex={1}>
        <Grid
          container
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
        >
          <NoDataIcon />
          <Typography variant="subtitle1">
            No workouts found for this week.
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction="column" spacing={1}>
      {planWeek?.workouts?.map((workout) => {
        const dayName = new Date(workout.date).toLocaleString("en-US", {
          weekday: "short",
        });
        const date = new Date(workout.date).toLocaleString("en-US", {
          day: "numeric",
        });

        return (
          <Grid item key={workout.id}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // backgroundColor: day.completed ? "#f8f9fa" : "white",
                // border: day.active ? "2px solid #4caf50" : "1px solid #e0e0e0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="subtitle1"
                    color={"#666"}
                    fontWeight={"bold"}
                    fontSize={"12px"}
                    textTransform={"uppercase"}
                  >
                    {dayName}
                  </Typography>
                  <Typography
                    variant="button"
                    sx={{
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                    }}
                  >
                    {date}
                  </Typography>
                </Box>
                {RenderWorkoutStatusCheck(workout.workoutStatusId)}
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {workout.workoutCategory.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {workout.name}
                  </Typography>
                </Box>
              </Box>
              <IconButton size="small">
                {/* eslint-disable-next-line */}
                {false ? (
                  <FavoriteIcon sx={{ color: "#f44336" }} />
                ) : (
                  <FavoriteBorderIcon />
                )}
              </IconButton>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
